import { ErrorModal, MesfModal, getMomentTz } from "@dexteel/mesf-core";
import { Button, CircularProgress, Grid, Typography } from "@material-ui/core";
import { useEffect } from "react";
import { useModalStyles } from "../../../../styles/modalStyles";
import { useCastersContext } from "../../../CastersContext";
import { ProcessData } from "./ProcessData";
import { ProductBatchSection } from "./ProductBatch/ProductBatch";
import { useDeliveryTicket } from "./hooks/useDeliveryTicket";

interface Props {
	show: boolean;
	onHide: (shouldUpdate: boolean) => void;
	processId: number;
}
export interface ProcessDataChanges {
	gradeId?: number | null;
	moldSizeId?: number | null;
	casterForeman?: string | null;
	melter?: string | null;
	labTech?: string | null;
	sequence?: string | null;
}
const moment = getMomentTz();

export const DeliveryTicketModal = ({ show, onHide, processId }: Props) => {
	const classes = useModalStyles();
	const { actions } = useCastersContext();

	const {
		isLoading,
		error,
		setError,
		deliveryTicket,
		moldSizes,
		errors,
		dateTimeFormatted,
		handleHeatInputChange,
		handleProductBatchChange,
		handleClickPrint,
		refreshProductBatches,
		setErrors,
		setPendingChanges,
		loadData,
	} = useDeliveryTicket(processId, show);

	useEffect(() => {
		if (show) {
			loadData();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [show]);
	return (
		<>
			<MesfModal
				open={show}
				handleClose={() => {
					onHide(true);
				}}
				id="delivery-ticket-modal"
				maxWidth="md"
			>
				{isLoading ? (
					<Grid
						container
						justifyContent="center"
						alignItems="center"
						style={{ padding: "560px 450px" }}
					>
						<CircularProgress size="5rem" />
					</Grid>
				) : (
					<>
						<MesfModal.Content
							className={`${classes.modalContent} ${classes.pageBreakAvoid}`}
							style={{
								border: "4px solid #ccc",
								borderRadius: 10,
								margin: "10px 20px",
							}}
						>
							<Grid
								container
								justifyContent="center"
								alignItems="center"
								direction="column"
								spacing={1}
								style={{ marginBottom: "30px" }}
							>
								<Grid item>
									<Typography
										variant="h6"
										align="center"
										style={{ fontWeight: "bold" }}
									>
										STEEL OF WEST VIRGINIA
									</Typography>
								</Grid>
								<Grid item>
									<Typography
										variant="h6"
										align="center"
										style={{ fontWeight: "bold" }}
									>
										MELTSHOP DELIVERY TICKET
									</Typography>
								</Grid>
							</Grid>
							<form noValidate autoComplete="off">
								<Grid container spacing={2} justifyContent="center">
									{/* Top fields */}
									<ProcessData
										dateTimeFormatted={dateTimeFormatted}
										setPendingChanges={setPendingChanges}
										deliveryTicket={deliveryTicket}
										handleHeatInputChange={handleHeatInputChange}
										errors={errors}
										setErrors={setErrors}
									/>

									{/* Lower section for strands */}
									<ProductBatchSection
										errors={errors}
										setErrors={setErrors}
										deliveryTicket={deliveryTicket}
										moldSizes={moldSizes}
										handleProductBatchChange={handleProductBatchChange}
										refreshProductBatches={refreshProductBatches}
										isLoading={isLoading}
									/>
								</Grid>
							</form>
						</MesfModal.Content>

						<MesfModal.Actions
							className={classes.noPrint}
							style={{ padding: "1rem 3rem" }}
						>
							<Grid container spacing={2} justifyContent="flex-end">
								<Grid item md={3} xs={3} style={{ margin: 0 }}>
									<Button
										fullWidth
										variant="contained"
										color="default"
										onClick={() => {
											actions.setRefreshInPause(false);
											errors.clear();
											onHide(true);
										}}
									>
										Close
									</Button>
								</Grid>
								<Grid item md={3} xs={3} style={{ margin: 0 }}>
									<Button
										fullWidth
										variant="contained"
										color="primary"
										onClick={handleClickPrint}
										disabled={!processId}
									>
										Save & print
									</Button>
								</Grid>
							</Grid>
						</MesfModal.Actions>
					</>
				)}
			</MesfModal>
			<ErrorModal
				error={error}
				onHide={() => {
					setError("");
				}}
			/>
		</>
	);
};
